import LoginResult from "./LoginResult";
import Env from "./Env";
import { ApolloClient } from "@apollo/client";
import * as __d3ett from "../rocket/D3ETemplate";
import { D3ETemplate } from "../rocket/D3ETemplate";
import D3EAppTemplate from "../models/D3EAppTemplate";
import GraphQLClientInit from "../utils/GraphQLClientInit";
import LocalDataStore from "../utils/LocalDataStore";
import ReferenceCatch from "../utils/ReferenceCatch";
import MessageDispatch from "../rocket/MessageDispatch";
import D3EAppTemplateCategoriesRequest from "../models/D3EAppTemplateCategoriesRequest";
import D3EFeature from "../models/D3EFeature";
import BuilderProject from "../models/BuilderProject";
import D3EAppTemplateCategories from "./D3EAppTemplateCategories";
import D3EFeatureBundle from "../models/D3EFeatureBundle";
import D3EFeaturebundles from "./D3EFeaturebundles";
import D3EFeaturebundlesRequest from "../models/D3EFeaturebundlesRequest";
import Developer from "../models/Developer";
import D3EAppTemplateCategory from "../models/D3EAppTemplateCategory";
import BaseUser from "../models/BaseUser";

export default class Query {
  private _client: ApolloClient<any>;
  private static _queryObject: Query;
  private _referenceCatch: ReferenceCatch;
  private constructor() {}
  private static _init() {
    let q = new Query();

    q._client = GraphQLClientInit.get();

    q._referenceCatch = ReferenceCatch.get();

    return q;
  }
  public static get() {
    if (Query._queryObject == null) {
      Query._queryObject = Query._init();
    }

    return Query._queryObject;
  }
  public async currentUser(): Promise<BaseUser> {
    GraphQLClientInit.token = await LocalDataStore.get().getToken();

    return await LocalDataStore.get().currentUser();
  }
  public async logout(): Promise<boolean> {
    LocalDataStore.get().setUser(null, null);

    await MessageDispatch.get().logout();

    return true;
  }
  public async getBuilderProjectById(
    usage: number,
    id: number
  ): Promise<BuilderProject> {
    return MessageDispatch.get().query(__d3ett.BUILDERPROJECT, id, usage);
  }
  public async getD3EAppTemplateById(
    usage: number,
    id: number
  ): Promise<D3EAppTemplate> {
    return MessageDispatch.get().query(__d3ett.D3EAPPTEMPLATE, id, usage);
  }
  public async getD3EAppTemplateCategoryById(
    usage: number,
    id: number
  ): Promise<D3EAppTemplateCategory> {
    return MessageDispatch.get().query(
      __d3ett.D3EAPPTEMPLATECATEGORY,
      id,
      usage
    );
  }
  public async getD3EFeatureById(
    usage: number,
    id: number
  ): Promise<D3EFeature> {
    return MessageDispatch.get().query(__d3ett.D3EFEATURE, id, usage);
  }
  public async getD3EFeatureBundleById(
    usage: number,
    id: number
  ): Promise<D3EFeatureBundle> {
    return MessageDispatch.get().query(__d3ett.D3EFEATUREBUNDLE, id, usage);
  }
  public async getDeveloperById(usage: number, id: number): Promise<Developer> {
    return MessageDispatch.get().query(__d3ett.DEVELOPER, id, usage);
  }
  public async loginDeveloperUserTypeWithEmailAndPassword(
    usage: number,
    d3eParams?: Partial<{
      email: string;
      password: string;
      deviceToken: string;
    }>
  ): Promise<LoginResult> {
    let email = d3eParams?.email;

    let password = d3eParams?.password;

    let deviceToken = d3eParams?.deviceToken;

    return MessageDispatch.get().login(
      "loginDeveloperUserTypeWithEmailAndPassword",
      usage,
      { email: email, password: password, deviceToken: deviceToken }
    );
  }
  public async loginWithOTP(
    usage: number,
    d3eParams?: Partial<{ token: string; code: string; deviceToken: string }>
  ): Promise<LoginResult> {
    let token = d3eParams?.token;

    let code = d3eParams?.code;

    let deviceToken = d3eParams?.deviceToken;

    return MessageDispatch.get().login("loginWithOTP", usage, {
      token: token,
      code: code,
      deviceToken: deviceToken,
    });
  }
  public async getD3EAppTemplateCategories(
    usage: number,
    request: D3EAppTemplateCategoriesRequest,
    d3eParams?: Partial<{ synchronize: boolean }>
  ): Promise<D3EAppTemplateCategories> {
    let synchronize = d3eParams?.synchronize;

    return MessageDispatch.get().dataQuery(
      "D3EAppTemplateCategories",
      usage,
      true,
      request,
      { synchronize: synchronize }
    );
  }
  public async getD3EFeaturebundles(
    usage: number,
    request: D3EFeaturebundlesRequest,
    d3eParams?: Partial<{ synchronize: boolean }>
  ): Promise<D3EFeaturebundles> {
    let synchronize = d3eParams?.synchronize;

    return MessageDispatch.get().dataQuery(
      "D3EFeaturebundles",
      usage,
      true,
      request,
      { synchronize: synchronize }
    );
  }
}
